import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=3ee07e4f&"
import script from "./BannerView.vue?vue&type=script&lang=js&"
export * from "./BannerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports